import React, {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect
} from 'react';

interface UserProviderProps {
  children: ReactNode;
}

interface UserContextType {
  user: null | {
    userId: string;
    role: string;
    avatar: string;
    firstName: string;
    lastName: string;
  };
  setUser: Dispatch<
    SetStateAction<null | {
      userId: string;
      role: string;
      avatar: string;
      firstName: string;
      lastName: string;
    }>
  >;
  signOut: () => void;
}

export const UserContext = createContext<UserContextType>(
  {} as UserContextType
);

export const UserProvider = ({ children }: UserProviderProps) => {
  const [user, setUser] = useState<null | {
    userId: string;
    role: string;
    avatar: string;
    firstName: string;
    lastName: string;
  }>(() => {
    // Retrieve user from localStorage during initialization
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // Update localStorage whenever user changes
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  const signOut = () => {
    // Clear user information on sign-out
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser: setUser as Dispatch<
          SetStateAction<{
            userId: string;
            role: string;
            avatar: string;
            firstName: string;
            lastName: string;
          } | null>
        >,
        signOut
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
